import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActionType } from '../../actions/model';

export interface Impersonation {
    isImpersonation: boolean;
}

const initialState: Impersonation = {
    isImpersonation: false
};

export const impersonationSlice = createSlice({
    name: '@@vp/impersonation',
    initialState,
    reducers: {

        setIsImpersonation(state, action: PayloadAction<Impersonation['isImpersonation']>): void {
            // sometimes get req returns 'OK'
            state.isImpersonation = action.payload === true;
        }
    },
    extraReducers: {
        [ActionType.LOGOUT]: (): Impersonation => initialState,
    }
});

export const {
    setIsImpersonation
} = impersonationSlice.actions;
